( function () {
  var app;
  /**
   * Our workhorse function.
   * Brings our sorting and filtering together and returns the item array back to the app.
   * The app will then take this and render it on the front end.
   * @return {Array} Our filtered and sorted items.
   */
   var items_filtered_sorted = function () {
    // Easier to pass these objects on here than trying to later.
    var
    items      = this.items,
    sort_by    = this.sort_by,
    sort_order = this.sort_order,
    gender     = this.gender,
    search     = this.search;

    // Filter it first.
    // The fuzzy search will mess with sorting otherwise.
    items = items_filter( items, gender, search );
    // Sort the items.
    items = items_sort( items, sort_order, sort_by );

    return items;
  };
  /**
   * Sort the items.
   * We handle all our sorting in this function.
   * @param  {Array}  items      Our array of items.
   * @param  {String} sort_order How should we sort the items, ascending or decending
   * @param  {String} sort_by    The key in the item to sort by
   * @return {Array}             The sorted item array.
   */
   var items_sort = function ( items, sort_order, sort_by ) {
    // Sort the items
    // Thankfully, sorting by properties is fairly straight forward.
    // We have this more advanced sort so it can do numbers and strings.
    items.sort( function ( a, b ) {
      if ( a[sort_by] < b[sort_by] ) {
        return -1;
      }
      if ( a[sort_by] > b[sort_by] ) {
        return 1;
      }
      // values must be equal
      return 0;
    } );

    // Decending order?
    // Simple, reverse the array.
    if ( 'DESC' === sort_order ) {
      items.reverse();
    }
    // The array of sorted items.
    return items;
  };
  /**
   * Filting function for items.
   * We do all of our filtering in this function.
   * @param  {Array}  items  Our array of items.
   * @param  {String} gender Gender that is currently selected in the app.
   * @param  {String} search Search that is currently typed into the app.
   * @return {Array}         An array of filtered items that match the params.
   */
   var items_filter = function ( items, gender, search ) {
    // Our fuse options
    // You could easily use a different library, but this one looked good to me!
    var options = {
      shouldSort: true,
      threshold: 0.3,
      minMatchCharLength: 2,
      keys: [
      'first_name',
      'last_name',
      'ip_address',
      'email'
      ]
    };
    // Fuse variable for later.
    var fuse;

    // Filter gender
    // Only do it if we actually selected a gender.
    if ( '' !== gender ) {
      // Return an array of matching items
      items = items.filter( function ( item ) {
        return item.gender === gender;
      } );
    }
    // Fuzzy search from Fuse for name, email, and IP
    if ( '' !== search ) {
      // Start up fuse.
      fuse = new Fuse( items, options );
      // Return an array of matching items from our search.
      items = fuse.search( search );
    }
    // Return our items after filtering
    return items;
  };
  /**
   * Starts up the app!
   * This is the callback from our getJSON function.
   * @param  {Array} json A JSON array of objects
   * @return {Null}
   */
   var app_start = function ( json ) {
    // Our app options object.
    var app_options = {
      el: '#app', // Element to target. Encases our form and results
      data: {
        items: [],
        sort_by: 'id', // Default sort by
        sort_order: 'ASC', // Default sort order
        gender: '', // Default gender (same as both)
        search: '' // Default search string
      },
      computed: {
        // Our sorting and filtering function.
        // Defining it this way makes the object cleaner.
        items_filtered_sorted: items_filtered_sorted
      }
    };    
    app = new Vue( app_options ); // Start up the app!
  };
  // Normally, I'd request this data via json.
  var items = [
    {
      "company_name": "Hammond's Candy Store",
      "company_website": "www.hammondcandies.com",
      "territory": "KY, IN"
    }, {
      "company_name": "Hammond's Candy Store",
      "company_website": "www.hammondcandies.com",
      "territory": "KY, IN"
    }, {
      "company_name": "Hammond's Candy Store",
      "company_website": "www.hammondcandies.com",
      "territory": "KY, IN"
    }
  ];
  // And this would be in the success of the ajax callback... if I had one.
  app_start();
  // Append the items.
  app.items = items;
} )();